<av-header></av-header>
<div class="app-layout px-2 gap-2">
    <app-navigation-menu />
    <div class="content-wrapper pb-2">
        <router-outlet></router-outlet>
    </div>
</div>
<av-footer></av-footer>